import { defineComponent } from "vue";
export default defineComponent({
  name: "Recharge",
  props: {
    title: {
      type: String,
      default: ""
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const onClickLeft = () => history.back();
    return {
      onClickLeft,
      props
    };
  }
});